import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const visibleFaqs = faqs.filter(f => f.answer.trim().length > 0);
  return <section aria-labelledby="faq-title" className="bg-ivory px-5 sm:px-8 py-16 sm:py-24" data-id="element-61" data-mp="1cfjcm29v4iov">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-12 gap-8 lg:gap-16" data-id="element-62" data-mp="2a2iecrfewgtm">
        <h2 id="faq-title" className="lg:col-span-4 font-serif text-3xl sm:text-[2.6rem] leading-tight font-semibold text-teal" data-id="element-63" data-mp="253f7d1fvg0j0">
          Domande frequenti
        </h2>

        <div className="lg:col-span-8 border-t border-ink/10" data-id="element-64" data-mp="2065jhq84rwxa">
          {visibleFaqs.map((faq, i) => {
          const isOpen = openIndex === i;
          const panelId = `faq-panel-${i}`;
          const buttonId = `faq-button-${i}`;
          return <div key={faq.question} className="border-b border-ink/10" data-id="element-65" data-mp="jpjfwqpimbx3" data-mpi={i}>
                <h3 className="font-sans" data-id="element-66" data-mp="1knqfza9l33yq">
                  <button id={buttonId} type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={panelId} className="w-full py-5 flex items-center justify-between gap-6 text-left" data-id="element-67" data-mp="1kp1mviybsru2">
                    <span className="font-serif text-lg font-semibold leading-snug text-teal" data-id="element-68" data-mp="1apanb2uwrmn4">
                      {faq.question}
                    </span>
                    <PlusIcon size={20} aria-hidden="true" className={`shrink-0 text-coral-deep transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-69" data-mp="11wz4a224j1h6" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-70" data-mp="s0dyvfm6zoct">
                  {isOpen && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-71" data-mp="wxmfhbrozkby">
                      <p className="pb-6 pr-10 text-base leading-relaxed text-ink/80 max-w-2xl" data-id="element-72" data-mp="2ku3q2wa5gutr">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}